import { motion, AnimatePresence } from "framer-motion";
import { FaTimes } from "react-icons/fa";
import logo1 from "../Assets/phantom.svg";
import logo3 from "../Assets/logo3.png";
import Rainbow from "../Assets/wall52.webp";
import Coinbase from "../Assets/logo4.png";
import MetaMask from "../Assets/wall7.webp";
import Ledger from "../Assets/wall28.png";

const wallets = [
  { name: "MetaMask", logo: MetaMask },
  { name: "Ledger", logo: Ledger },
  { name: "Phantom", logo: logo1 },
  { name: "WalletConnect", logo: logo3, alt: true },
  { name: "Rainbow", logo: Rainbow },
  { name: "Coinbase Wallet", logo: Coinbase },
];

export default function ConnectWalletModal({
  isOpen,
  onClose,
  setShowModal2,
  setShowModal3,
}) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-end justify-center p-4 md:items-center bg-black/70 backdrop-blur-md">
          <motion.div
            initial={{ y: "100%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: "100%", opacity: 0 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            className="relative flex flex-col md:flex-row w-full max-w-[760px] overflow-hidden bg-white shadow-2xl rounded-3xl"
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute flex items-center justify-center transition bg-gray-100 rounded-full w-9 h-9 top-4 right-4 hover:bg-gray-200"
            >
              <FaTimes size={12} className="text-gray-600" />
            </button>

            {/* LEFT SIDE */}
            <div className="w-full md:w-[45%] p-7 border-r border-gray-100">
              <h2 className="mb-6 text-xl font-bold text-gray-900">
                Connect Wallet
              </h2>

              {/* Wallet List (no scrollbar) */}
              <div className="flex flex-col gap-2">
                {wallets.map((wallet, i) => (
                  <button
                    key={i}
                    onClick={() => {
                      onClose();
                      wallet?.alt ? setShowModal3(true) : setShowModal2(true);
                    }}
                    className="flex items-center gap-4 p-3 transition-all bg-gray-50 rounded-xl hover:bg-gray-100 hover:scale-[1.02]"
                  >
                    <img
                      src={wallet.logo}
                      alt={wallet.name}
                      className="object-contain w-10 h-10 p-1 bg-white border rounded-full"
                    />

                    <span className="font-semibold text-gray-800">
                      {wallet.name}
                    </span>
                  </button>
                ))}
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="hidden md:flex flex-col justify-center w-[55%] p-10 bg-gradient-to-br from-gray-900 to-black text-white">
              <h2 className="mb-10 text-2xl font-bold">What is a Wallet?</h2>

              <div className="space-y-8">
                <div className="flex gap-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-white/10">
                    <span className="text-xl">📦</span>
                  </div>

                  <div>
                    <h3 className="font-semibold text-[15px]">
                      Store Digital Assets
                    </h3>

                    <p className="text-sm text-gray-400">
                      Wallets store crypto assets like Ethereum, tokens, and
                      NFTs.
                    </p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-white/10">
                    <span className="text-xl">🔑</span>
                  </div>

                  <div>
                    <h3 className="font-semibold text-[15px]">
                      Login with Wallet
                    </h3>

                    <p className="text-sm text-gray-400">
                      Connect your wallet instead of creating usernames and
                      passwords.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-12 space-y-4">
                <button className="w-full py-3 font-semibold text-black transition bg-white rounded-full hover:bg-gray-200">
                  Get a Wallet
                </button>

                <button className="w-full text-sm font-medium text-gray-400 hover:text-white">
                  Learn More
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
